<template>
  <router-link
    :to="view.startLinkParams(doc)"
    class="releases-block__item"
    :class="{ 'releases-block__item--safari': isSafari }"
  >
    <BookCover :doc="doc" coverClass="releases-block__img" />
    <div class="releases-block__text">
      <h5 class="releases-block__category card-large__category">
        {{ view.firstTagShort(doc) }}
      </h5>
      <h3 class="releases-block__title card-large__title">
        {{ doc.title }}
      </h3>
      <h4 class="releases-block__author card-large__author">
        By {{ doc.author }}
      </h4>
    </div>
    <BookCardBackground v-if="!isSafari" :doc="doc" />
  </router-link>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import type { Book } from '@/models/interfaces'
import type { BooksView } from '@/models/doc.book'
import { platform } from '@/services/platform'
import { isSafari as _isSafari } from '@/helpers/userAgent'

import BookCover from '@/app/components/book/card/BookCover.vue'
import BookCardBackground from '@/app/components/book/card/BookCardBackground.vue'

defineProps<{
  doc: Book
  view: BooksView
}>()

const isSafari = ref(false)

onBeforeMount(async () => {
  isSafari.value = (await platform.isIOS()) || _isSafari()
})
</script>
